export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    namePt: 'Tênis',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    badge: 'Hot',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    namePt: 'Moletons',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    badge: 'Novo',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    namePt: 'Camisetas',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    badge: 'Popular',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    namePt: 'Jaquetas',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    badge: '',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    namePt: 'Calças/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    badge: '',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    namePt: 'Chapéus/Bonés',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    badge: '',
  },
  {
    id: 'sets',
    name: 'Sets',
    namePt: 'Conjuntos',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    badge: 'Trending',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    namePt: 'Roupa Íntima',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    badge: '',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    namePt: 'Camisas Esportivas',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    badge: '',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    namePt: 'Acessórios',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    badge: '',
  },
  {
    id: 'bags',
    name: 'Bags',
    namePt: 'Bolsas',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    badge: '',
  },
  {
    id: 'belts',
    name: 'Belts',
    namePt: 'Cintos',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    badge: '',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    namePt: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    badge: '',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    namePt: 'Outros Itens',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    badge: '',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const articleEntry = {
  id: 'guia-seo',
  namePt: 'Guia CSSBuy',
  subtitlePt: 'Domine a planilha em 5 minutos',
  url: '/artigo/guia-cssbuy-spreadsheet',
};